<template>
  <div class="content-wrapper">
    <section class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1>Custom Permission</h1>
          </div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <li class="breadcrumb-item">
                <router-link :to="{ name: 'Home' }">Home</router-link>
              </li>
              <li class="breadcrumb-item active">Custom Permission</li>
            </ol>
          </div>
        </div>
      </div>
    </section>
    <section class="content">
      <!-- Default box -->
      <div class="card">
        <div class="overlay" v-if="is_loading">
          <i class="fas fa-2x fa-sync-alt fa-spin"></i>
        </div>
        <form @submit.prevent="saveItem" method="POST" novalidate>
          <div class="card-header">
            <h3 class="card-title" v-if="!is_edit">Create</h3>
            <h3 class="card-title" v-if="is_edit">Edit</h3>
            <div class="card-tools">
              <router-link
                class="btn btn-info"
                :to="{ name: 'CustomPermissions' }"
                ><i class="fas fa-list"></i> List
              </router-link>
            </div>
          </div>
          <div class="card-body">
            <div class="form-group required">
              <label for="permission_name" class="control-label"
                >Permission name</label
              >
              <input
                type="text"
                id="permission_name"
                name="permission_name"
                v-model="item.permission_name"
                v-validate="'required'"
                class="form-control"
                :class="{ 'has-error': errors.has('permission_name') }"
                placeholder="Permission name"
              />
              <div
                class="help text-danger"
                v-show="errors.has('permission_name')"
              >
                {{ errors.first("permission_name") }}
              </div>
            </div>
          </div>
          <!-- /.card-body -->
          <div class="card-footer">
            <button
              type="submit"
              v-if="is_edit === false"
              class="btn btn-primary"
            >
              Submit
            </button>
            <button
              type="submit"
              v-if="is_edit === true"
              class="btn btn-primary"
            >
              Update
            </button>
          </div>
        </form>
      </div>
    </section>
  </div>
</template>
<script>
import { CustomPermissionAPI } from "@/services/api";
export default {
  name: "CustomPermissionForm",
  data: () => ({
    params: "",
    item: {},
    is_edit: false,
    is_loading: false,
  }),
  methods: {
    saveItem: function (e) {
      this.$validator.validateAll().then((result) => {
        if (result) {
          if (this.is_edit) {
            CustomPermissionAPI.update(this.params.id, this.item)
              .then((response) => {
                this.$router.push({ name: "CustomPermissions" });
                this.$toaster.success(response.message);
              })
              .catch((error) => {
                this.$setErrorsFromResponse(error.data);
              });
          } else {
            CustomPermissionAPI.store(this.item)
              .then((response) => {
                this.$router.push({ name: "CustomPermissions" });
                this.$toaster.success(response.message);
              })
              .catch((error) => {
                this.$setErrorsFromResponse(error.data);
              });
          }
        }
      });
    },
    itemDetail: function (id) {
      return new Promise((resolve) => {
        let _this = this;
        CustomPermissionAPI.show(id)
          .then((response) => {
            _this.item = response;
            resolve("resolved");
          })
          .catch((error) => {
            resolve("rejected");
          });
      });
    },
    async getInitialData() {
      let _this = this;
      _this.params = _this.$route.params;
      if (!_.isEmpty(_this.params) && _this.params.id !== undefined) {
        _this.is_edit = true;
      }
      _this.is_loading = true;
      if (_this.is_edit === true) {
        await this.itemDetail(_this.params.id);
      }
      _this.is_loading = false;
    },
  },
  mounted: function () {
    let _this = this;
    _this.getInitialData();
  },
};
</script>
